import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="text-xl font-display font-bold text-white flex items-center gap-2">
              <span className="text-2xl">🍽️</span> Khana Spot 
            </Link>
            <p className="mt-3 text-sm text-gray-400 leading-relaxed">
              Connecting you with the best restaurants in Burewala and Vehari. 
              Fresh food, fast delivery.
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-white font-semibold mb-3">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/restaurants" className="hover:text-orange-400 transition-colors">All Restaurants</Link></li>
              <li><Link to="/login" className="hover:text-orange-400 transition-colors">Sign In</Link></li>
              <li><Link to="/register" className="hover:text-orange-400 transition-colors">Create Account</Link></li>
              <li><Link to="/my-orders" className="hover:text-orange-400 transition-colors">My Orders</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-3">Cities We Serve</h3>
            <div className="space-y-2 text-sm">
              <div className="flex items-center gap-2"><MapPin className="w-4 h-4 text-orange-400" /> Burewala, Punjab</div>
              <div className="flex items-center gap-2"><MapPin className="w-4 h-4 text-orange-400" /> Vehari, Punjab</div>
            </div>
            <div className="mt-4 flex gap-3">
              <a
                href={`https://wa.me/${process.env.REACT_APP_ADMIN_WHATSAPP || "923001234567"}`}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-1.5 bg-green-600 hover:bg-green-700 text-white text-xs px-3 py-2 rounded-lg transition-colors"
              >
                <MessageCircle className="w-3.5 h-3.5" /> WhatsApp
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-gray-800 flex flex-col sm:flex-row justify-between items-center text-xs text-gray-500">
          <p>© {new Date().getFullYear()} Khana Spot. All rights reserved.</p>
          <p className="mt-2 sm:mt-0">Made with ❤️ in Pakistan</p>
        </div>
      </div>
    </footer>
  );
}
